import { inject, Injectable } from '@angular/core';
import { StateService, Transition } from '@uirouter/core';

const PURCHASE_STATE_PREFIX = 'apps.purchase';
const FALLBACK_STATE = 'apps.home';

@Injectable({
  providedIn: 'root',
})
export class PurchaseExitService {
  private stateService = inject(StateService);

  /**
   * Leaves the purchase flow, returning to the state the user came from.
   *
   * Navigates by state rather than by URL string: `UrlService.url()` silently
   * does nothing when the string matches the current URL, and a raw path drops
   * the query string (`?cid=`) and any state params. Falling back to
   * `apps.home` also keeps the user out of the purchase flow when it was
   * opened directly, which would otherwise re-enter it through
   * `apps.purchase.home`'s resolve now that the company is subscribed.
   */
  exit(transition: Transition): void {
    const from = transition.from();
    const returnsToPurchase =
      !from?.name || from.name.indexOf(PURCHASE_STATE_PREFIX) === 0;

    const target = returnsToPurchase ? FALLBACK_STATE : from.name;
    const params = returnsToPurchase ? {} : transition.params('from');

    this.stateService.go(target, params).catch((error) => {
      console.error('Failed to leave the purchase flow.', error);
    });
  }
}
